import { render, staticRenderFns } from "./EmmagatzemarBalesPF.vue?vue&type=template&id=89470dbe&scoped=true"
import script from "./EmmagatzemarBalesPF.vue?vue&type=script&lang=js"
export * from "./EmmagatzemarBalesPF.vue?vue&type=script&lang=js"
import style0 from "./EmmagatzemarBalesPF.vue?vue&type=style&index=0&id=89470dbe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89470dbe",
  null
  
)

export default component.exports